import './Ahmedabad.css';

export const Ahmedabad = {
    title: "Ahmedabad",
    title1: "(Heritage)",
    attractions: [
        {
            name: "Sabarmati Ashram",
            description: "Once the residence of Mahatma Gandhi, this ashram is now a museum showcasing his life and teachings. The ashram played a crucial role in India's independence movement and remains a symbol of peace and non-violence. Visitors can explore various sections like Hriday Kunj, where Gandhi lived, and the library that houses books and letters written by him.",
            location: "Gandhi Smarak Sangrahalaya, Ashram Road, Ahmedabad",
            timings: "8:30 AM to 6:30 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Early Morning or Late Afternoon",
            activities: [
                "Explore Gandhi's personal artifacts",
                "Visit the museum",
                "Walk along the peaceful Sabarmati River",
                "Attend meditation and prayer sessions in the ashram",
                "Shop for Khadi and handmade products at the souvenir shop"
            ],
            mapLink: "https://maps.app.goo.gl/gdaE3psZrUXZQKNi9",
        },
        {
            name: "Kankaria Lake",
            description: "A picturesque lake offering attractions like a zoo, toy train, and amusement parks, making it a perfect family destination. The lakefront is a well-developed area with an array of entertainment options such as water rides, a food court, and open-air theater. The musical fountain and light shows in the evening enhance the overall experience.",
            location: "Maninagar, Ahmedabad",
            timings: "9:00 AM to 10:00 PM",
            ticket: "₹25 for adults, ₹10 for children below 12 years, free for differently-abled individuals and senior citizens. Additional charges apply for specific attractions and activities.",
            bestTimeToVisit: "Evening for a scenic view and leisure activities",
            activities: [
                "Enjoy a boat ride on the serene waters",
                "Explore Kankaria Zoo, home to diverse wildlife",
                "Experience the toy train ride around the lake",
                "Visit the amusement park for fun rides",
                "Enjoy street food at the lakefront eateries",
                "Watch the mesmerizing laser show in the evening"
            ],
            mapLink: "https://maps.app.goo.gl/dd9AWymJooT8wv2YA",

        },
        {
            name: "Sidi Saiyyed Mosque",
            description: "Famous for its iconic 'Tree of Life' jali (lattice) window, this mosque is a fine example of Indo-Islamic architecture. Built in 1573 by Sidi Saiyyed, a noble of the Gujarat Sultanate, the mosque features intricate stone carvings that have become a symbol of Ahmedabad's architectural heritage.",
            location: "Lal Darwaja, Ahmedabad",
            timings: "Open 24 Hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Early morning for a peaceful visit",
            activities: [
                "Admire the beautiful latticework",
                "Capture stunning photographs",
                "Learn about Indo-Islamic architecture and history",
                "Experience the serene ambiance of the mosque",
                "Explore nearby markets for local handicrafts"
            ],
            mapLink: "https://maps.app.goo.gl/7T6fvLnF42LpYjqK6",

        },
        {
            name: "Sabarmati Riverfront",
            description: "A scenic promenade along the Sabarmati River, ideal for leisurely walks, cycling, and enjoying the city's skyline. The riverfront offers well-maintained walkways, gardens, and recreational facilities, making it a popular spot for locals and tourists alike.",
            location: "Ashram Road, Ahmedabad",
            timings: "6:00 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Sunset for a mesmerizing view",
            activities: [
                "Walk along the promenade",
                "Go cycling",
                "Enjoy street food at the riverfront stalls",
                "Attend cultural events and exhibitions",
                "Relax in the lush green gardens"
            ],
            mapLink: "https://maps.app.goo.gl/JNf72KpGsLCkSPkPA",
        },
        {
            name: "Manek Chowk",
            description: "A bustling market square in the old city, known for its jewelry shops in the daytime and its transformation into a vibrant street food hub at night. It is famous for unique food items like the chocolate sandwich and the enormous bhaji pav.",
            location: "Old Ahmedabad",
            timings: "24 Hours (Street Food starts at 8:00 PM)",
            ticket: "Free Entry",
            bestTimeToVisit: "Night for street food",
            activities: [
                "Try local street food like pav bhaji, dosa, and kulfi",
                "Shop for traditional jewelry and textiles",
                "Experience the lively atmosphere of the night market"
            ],
            mapLink: "https://maps.app.goo.gl/FkRxrrLkmZSMGvrV8",
        },
        {
            name: "Hutheesing Jain Temple",
            description: "A stunning Jain temple built in 1848 with exquisite marble carvings and intricate architecture, dedicated to Lord Dharmanath, the 15th Jain Tirthankara.",
            location: "Shahibaug, Ahmedabad",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning for a peaceful visit",
            activities: [
                "Admire the marble architecture and intricate carvings",
                "Learn about Jain heritage and rituals",
                "Experience the spiritual ambiance"
            ],
            mapLink: "https://maps.app.goo.gl/GRTTN2FwZCSJt91v8",
        },
        {
            name: "Auto World Vintage Car Museum",
            description: "A paradise for automobile lovers, featuring a rare collection of vintage cars, including Rolls Royce, Bentley, Cadillac, and Mercedes models from different eras.",
            location: "Dastan Estate, Kathwada, Ahmedabad",
            timings: "8:00 AM to 9:00 PM",
            ticket: "₹100 per person, ₹50 for children below 12 years",
            bestTimeToVisit: "Morning to explore all exhibits",
            activities: [
                "See classic vintage cars",
                "Learn about automobile history",
                "Take photographs with luxurious vehicles"
            ],
            mapLink: "https://maps.app.goo.gl/r1NAg7u2QBPyBCgQ7",
        },
        {
            name: "Science City",
            description: "An educational and entertainment hub featuring an IMAX theater, planetarium, robotics gallery, and an interactive science museum. The place is ideal for families, students, and science enthusiasts looking for an immersive learning experience.",
            location: "Sola, Ahmedabad",
            timings: "10:00 AM to 7:30 PM (Closed on Mondays)",
            ticket: "General Entry: ₹50 per person; IMAX 3D Movie: ₹150 per person; Multimedia Laser and Fountain Show: ₹90 per person. Additional charges apply for specific attractions and activities.",
            bestTimeToVisit: "Afternoon to explore all attractions",
            activities: [
                "Watch IMAX 3D movies",
                "Visit the Space and Robotics Gallery",
                "Experience hands-on science experiments",
                "Explore the musical fountain and laser shows"
            ],
            mapLink: "https://maps.app.goo.gl/f7xBuhkYZrpL4sGD7",
        },
        {
            name: "Vastrapur Lake",
            description: "A serene lake in the heart of Ahmedabad, surrounded by a walking track, gardens, and an open-air theater for cultural performances. The lake becomes lively in the evening with street food stalls and fitness enthusiasts.",
            location: "Vastrapur, Ahmedabad",
            timings: "6:00 AM to 10:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Evening for relaxation",
            activities: [
                "Take a peaceful walk around the lake",
                "Enjoy cultural performances at the open-air theater",
                "Try local snacks from the street food stalls"
            ],
            mapLink: "https://maps.app.goo.gl/e9vWzv8Pqr6guW767",
        },
        {
            name: "Shree Swaminarayan Mandir Kalupur",
            description: "A historic temple built in 1822, known for its intricate wooden carvings and colorful architecture. It is the first Swaminarayan temple in the world and a significant spiritual site in Ahmedabad.",
            location: "Kalupur, Ahmedabad",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or during evening prayers",
            activities: [
                "Experience the spiritual atmosphere",
                "Admire the stunning temple architecture",
                "Learn about Swaminarayan history and traditions"
            ],
            mapLink: "https://maps.app.goo.gl/Asc4b9Bo2dqQ1dsn7",
        },
        {
            name: "Adalaj Stepwell",
            description: "A stunning Indo-Islamic stepwell built in the 15th century, featuring intricate carvings and a unique multi-level structure. It served as a water reservoir and a resting place for travelers, showcasing beautiful architecture and historical significance.",
            location: "Adalaj, Near Ahmedabad",
            timings: "8:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Explore the intricate carvings",
                "Learn about the history of stepwells",
                "Capture stunning photographs of the architecture"
            ],
            mapLink: "https://maps.app.goo.gl/oqfGbDHDnWxHzKmp6",
        },
        {
            name: "Bhadra Fort",
            description: "A historic fort built in the 15th century, featuring a palace, a temple, and an open courtyard used for royal ceremonies.",
            location: "Court Road, Ahmedabad",
            timings: "9:00 AM to 5:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning",
            activities: [
                "Explore the fort’s architecture",
                "Visit the Bhadrakali Temple inside",
                "Learn about the historical significance of the fort"
            ],
            mapLink: "https://maps.app.goo.gl/8B4WK6ooqQtiSbvx6",
        },
        {
            name: "Jama Masjid",
            description: "Built in 1424, this mosque is a blend of Hindu and Muslim architectural styles with 260 intricately carved pillars.",
            location: "Manek Chowk, Ahmedabad",
            mapLink: "https://goo.gl/maps/ThXAGmTkTnE2",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning",
            activities: [
                "Admire the intricate architecture",
                "Explore the vast courtyard"
            ],
            mapLink: "https://maps.app.goo.gl/TCjGDGopnYQ9hZ278",
        },
        {
            name: "Sarkhej Roza",
            description: "An architectural complex comprising mosques, tombs, and palaces, Sarkhej Roza reflects the Indo-Saracenic style. It's often referred to as the 'Acropolis of Ahmedabad' due to its grandeur.",
            location: "Sarkhej, Ahmedabad",
            timings: "9:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Evening",
            activities: [
                "Explore the historic structures",
                "Relax by the tranquil water bodies",
                "Capture the serene ambiance through photography"
            ],
            mapLink: "https://maps.app.goo.gl/sdRkzfsn3NNQxRJv5",
        },
        {
            name: "Vechaar Utensils Museum",
            description: "A unique museum dedicated to traditional Indian utensils, showcasing a vast collection of kitchenware from different eras and regions.",
            location: "Vishalla, Opposite Vasna Tol Naka, Ahmedabad",
            timings: "3:00 PM to 10:30 PM",
            ticket: "₹10 for adults, ₹5 for children",
            bestTimeToVisit: "Evening",
            activities: [
                "Explore the extensive utensil collection",
                "Dine at the adjacent Vishalla restaurant serving traditional Gujarati cuisine",
                "Experience the rustic village ambiance"
            ],
            mapLink: "https://maps.app.goo.gl/Gcu6jvW94tipho6Z9",
        },
        {
            name: "Thol Lake Bird Sanctuary",
            description: "A peaceful sanctuary that is home to many species of migratory birds, including flamingos, pelicans, and cranes.",
            location: "Thol Village, Near Ahmedabad",
            timings: "6:00 AM to 6:00 PM",
            ticket: "₹50 per person, ₹200 per car",
            bestTimeToVisit: "Early Morning (for birdwatching)",
            activities: [
                "Birdwatching (bring binoculars)",
                "Enjoy a peaceful lakeside walk",
                "Capture beautiful photographs of nature"
            ],
            mapLink: "https://maps.app.goo.gl/ZSXhGzjYy1wtxvZ66",
        },
        {
            name: "Vaishnodevi Temple",
            description: "A replica of the famous Vaishno Devi temple in Jammu, known for its cave-like structure and spiritual ambiance.",
            location: "SG Highway, Ahmedabad",
            timings: "5:00 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Experience the cave-like temple structure",
                "Participate in prayers and Aarti",
                "Enjoy the peaceful atmosphere"
            ],
            mapLink: "https://maps.app.goo.gl/JicmqytChN7hUd9Y8",
        },
        {
            name: "Indroda Nature Park",
            description: "Known as India's Jurassic Park, this park features life-sized dinosaur models, a botanical garden, and a fossil park.",
            location: "Gandhinagar (Near Ahmedabad)",
            timings: "8:00 AM to 6:00 PM",
            ticket: "₹30 for adults, ₹15 for children",
            bestTimeToVisit: "Morning",
            activities: [
                "Explore the dinosaur fossil park",
                "Visit the botanical gardens",
                "Enjoy nature and wildlife spotting"
            ],
            mapLink: "https://maps.app.goo.gl/6ZHHAeHH1Wuxm1Ui7",
        },
        {
            name: "Nal Sarovar Bird Sanctuary",
            description: "A large wetland reserve that is home to many migratory birds, best explored by boat.",
            location: "Near Sanand, Ahmedabad",
            timings: "6:00 AM to 6:00 PM",
            ticket: "₹60 per person, ₹220 per boat",
            bestTimeToVisit: "Early Morning",
            activities: [
                "Go for a boat ride to spot birds",
                "Enjoy photography of nature and wildlife",
                "Observe flamingos, pelicans, and other migratory birds"
            ],
            mapLink: "https://maps.app.goo.gl/amvHBNyeBwzj62Zt6",
        },
        {
            name: "Sarita Udhyan",
            description: "A scenic garden along the banks of the Sabarmati River, offering a peaceful escape from city life.",
            location: "Gandhinagar (Near Ahmedabad)",
            timings: "5:00 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Relax in a beautiful garden setting",
                "Enjoy a peaceful riverside walk",
                "Have a picnic with family and friends"
            ],
            mapLink: "https://maps.app.goo.gl/QdH8ZtAAoFGb4nTA6",
        },
        {
            name: "Shanku’s Water Park",
            description: "One of the largest water parks in Gujarat, featuring thrilling water slides, pools, and entertainment activities.",
            location: "Mehsana Highway, Ahmedabad",
            timings: "10:00 AM to 6:00 PM",
            ticket: "₹800 per person",
            bestTimeToVisit: "Afternoon",
            activities: [
                "Enjoy thrilling water slides",
                "Relax in the wave pool",
                "Spend a fun-filled day with family and friends"
            ],
            mapLink: "https://maps.app.goo.gl/DZfbE7P2rCKe6dfE7",
        }
    ]
};


    
